import { configBuilder } from "ccui-framework";
import { commonConfig } from "../../../src/config/partner";

const Config = {
  amazon: {
    ...commonConfig,

    reduxLogger: false,
    basename: "amazon",
    //layout
    layoutVersion: 2,
    exchangeMastVersion: 2,
    // Verification
    verificationType: "tlo",
    // meta
    paymentType: "Gift Card",
    aOrAn: "an",
    partnerBrand: "Amazon.com",
    partnerURL: "http://www.amazon.com/",
    partnerEmail: "support@cardcash.com",
    giftCardTerms:
      "https://www.amazon.com/gp/help/customer/display.html?nodeId=3122091",
    termsAndConditionsBuilder: (config) => `amazon.com/gc-legal`,

    // social
    facebookURL: "https://www.facebook.com/CardCash/",
    twitterURL: "https://twitter.com/CardCash",
    youTubeURL: null,
    instagramURL: "https://www.instagram.com/cardcash",
    googleURL: null,
    linkedInURL: null,
    pinterestURL: "https://www.pinterest.com/cardcash/",

    // api
    googleAnalytics: "UA-71687019-1",
    x_cc_app: "tBZjaaj6Z", // amazon
    baseURL: "https://production-api.cardcash.com/",
    identityCardInfoTitle: "Enter Credit Card",
    // header
    headerMenuItemOrder: ["backToItem", "faqItem"],
    headerMenuFaqItem: {
      text: (config) => "FAQ",
    },
    headerMenuBackToItem: {
      text: (config) => `Back to ${config.partnerBrand}`,
    },
    headerLogoOrder: ["headerLogoCC"],

    headerLogoCCIcon:
      "https://cdn.cardcash.com/website/partners/common/card_cash_logo.png",

    exchangeMastCardImageUrl:
      "https://cdn.cardcash.com/website/partners/amazon/exchange-mast-0/amazon_card.png",
    orderCompleteCardImageUrl:
      "https://cdn.cardcash.com/website/partners/amazon/exchange-mast-0/amazon_card.png",

    exchangeMastMultiLineBrandLogoUrlV2:
      "https://cdn.cardcash.com/website/partners/amazon/exchange-mast-0/amazon_multiline_logo.svg",
    //exchange mast
    exchangeMastTextPartTwoV1: "for a Starbucks Gift Card",

    // steps
    stepsVersion: 3,
    stepsV3Text: [
      [
        "Get Offer",
        "Tell us about the brand and balance and get an instant offer.",
      ],
      ["Provide Details", "Enter the details for your gift card."],
      ["Verify Your Identity", "To help us protect everyone from fraudsters."],
      [
        "Receive your Amazon.com Gift Card",
        "Your gift card will be emailed to you within 1 business day.",
      ],
    ],

    // offer
    offerButtonTxt: "Get Instant Offer",
    offerButtonTxtMany: "Get Instant Offer",
    offerBalanceInputPlaceHolder: "$ Remaining Balance",

    // card number and pin input boxs
    cardNumberPlaceHolderText: "Gift Card Number",
    cardPinPlaceHolderText: "PIN",

    // Have another card? Add it here?
    haveAnotherCardShowPopup: false,
    theme: {
      activeColor: "#FC9F03",
      inactiveColor: "#ffd38e",
      nav_backgroundColor: "#24303c",
      nav_linkColor: "white",
      background: {
        phone: {
          color: "#0096c8",
          position: "33% 0%",
          size: "100%",
          url: "https://cdn.cardcash.com/website/partners/amazon/amazon_mobile_background.jpg",
        },
        desktop: {
          color: "#0096c8",
          position: "-15% 68%",
          size: "150%",
          url: "https://cdn.cardcash.com/website/partners/amazon/amazon_background.jpg",
        },
        iPad: {
          color: "#0096c8",
          position: "47% 126%",
          size: "189% auto",
          url: "https://cdn.cardcash.com/website/partners/amazon/amazon_background.jpg",
        },
        iPadPro: {
          color: "#0096c8",
          position: "45% 111%",
          size: "210% auto",
          url: "https://cdn.cardcash.com/website/partners/amazon/amazon_background.jpg",
        },
      },
    },
    faq: {
      content: (config) => {
        return [
          {
            question: "How much will I receive in return for my gift card?",
            answer:
              "Every brand is different. In order to find the exchange value for your card, please enter the brand name of the gift card and the balance to receive an offer. You are under no obligation to exchange your card, and we will not retain your gift card information if you do not confirm your exchange.",
          },
          {
            question: "Do you accept partially used cards or uneven balances?",
            answer:
              "Yes, we accept gift cards with any balance remaining on the gift card.",
          },
          {
            question: "Do I need to mail in my gift card?",
            answer: "No, you do not need to mail in your card.",
          },
          {
            question: "Can I exchange more than one gift card?",
            answer:
              'Yes, you can exchange more than one gift card. To trade in more than one, click the "Add Another Card" link.',
          },
          {
            question: `When will I receive my ${config.partnerBrand} ${config.paymentType}?`,
            answer: `As soon as you finish the process, your ${config.partnerBrand} ${config.paymentType} will be issued and emailed to you within 1 business day.`,
          },
          {
            question:
              "Can I get better rates for my cards or is it the same for all gift cards?",
            answer:
              "Our rates are determined by market pricing, which is affected by several factors. In order to find the rate for your card, please enter your gift card information to receive an offer. You are under no obligation to sell your card, and we will not retain your gift card information if you do not confirm your exchange. Please note that the offer you see displayed for the same gift card of the same value may change from time to time.",
          },
          {
            question: `I received ${config.aOrAn} ${config.partnerBrand} ${config.paymentType} of lesser value than what you offered.`,
            answer: `If you believe this was in error, please contact by email at $${config.partnerEmail}`,
          },
          {
            question: `Where can I find my ${config.partnerBrand} ${config.paymentType}?`,
            answer: "Your card will be emailed to you upon order approval.",
          },
          {
            question: "What do you do with the gift cards?",
            answer:
              "CardCash.com is one of the biggest gift card exchanges in the world. We repurpose and then resell the gift cards at a discounted rate on our website.",
          },
          {
            question: "I changed my mind. How do I get my card back?",
            answer:
              "We're sorry; once you've accepted the offer, the sale is final.",
          },
          {
            question: "Do you accept merchandise credits?",
            answer: "Yes.",
          },
          {
            question: "Do you accept cards with expiration dates?",
            answer:
              "No, unfortunately, we cannot accept gift cards that have an expiration date.",
          },
          {
            question: "I’m still confused, how can I reach you?",
            answer: `Our customer service department can be reached during normal business hours or by email at ${config.partnerEmail}`,
          },
          {
            question:
              "Can you tell me more about the current Amazon promo you are running?",
            answer:
              "Sure. The Amazon promotional $5 gift card is available only for customers who have never placed a trade for Amazon order on any CardCash platform. Orders will be eligible only if the total face value of the cards being traded in equals at least $100. CardCash reserves the right to determine customer eligibility and to disqualify customers that we determine to have already placed Amazon trade orders under alternate accounts. CardCash reserves the right to end this promotion at any time without prior notice. Bonus gift cards may take up to one full business week to arrive.",
          },
        ];
      },
    },
  },
  "test.cardcash.com": {
    basename: null,
    devMode: "integration",
    googleAnalytics: "",
    x_cc_app: "fGawiFdMi",
    baseURL: "https://integration-api.cardcash.com/",
    reduxLogger: true,
  },
  localhost: {
    basename: null,
    devMode: "development",
    googleAnalytics: "",
    x_cc_app: "fGawiFdMi",
    baseURL: "https://integration-api.cardcash.com/",
    reduxLogger: true,
  },
};

export const configModule = configBuilder("amazon", Config);
